import React__default from "react";
import { useMediaQuery } from "react-responsive";
import { breakPointOrder } from "../../theme-provider/theme-provider.mjs";
import { useTheme } from "../../theme-provider/use-theme.mjs";
import { useIsMounted } from "./use-is-mounted.mjs";
const reversedBreakPointOrder = [...breakPointOrder].reverse();
function useCurrentBreakPoint() {
  const { media } = useTheme();
  const isMounted = useIsMounted();
  const isXs = useMediaQuery({ minWidth: media.width.xs.min });
  const isSm = useMediaQuery({ minWidth: media.width.sm.min });
  const isMd = useMediaQuery({ minWidth: media.width.md.min });
  const isLg = useMediaQuery({ minWidth: media.width.lg.min });
  const isXl = useMediaQuery({ minWidth: media.width.xl.min });
  const isXxl = useMediaQuery({ minWidth: media.width.xxl.min });
  const currentBreakPoint = React__default.useMemo(() => {
    const matches = {
      xs: isXs,
      sm: isSm,
      md: isMd,
      lg: isLg,
      xl: isXl,
      xxl: isXxl
    };
    return reversedBreakPointOrder.find((breakPoint) => matches[breakPoint]);
  }, [isXs, isSm, isMd, isLg, isXl, isXxl]);
  if (!isMounted) {
    return null;
  }
  return currentBreakPoint != null ? currentBreakPoint : "xs";
}
export {
  useCurrentBreakPoint
};
